import { AICodingJobDetailsDto } from "app/V2ApiClient";
import { VariableItemVM } from "./aiCodingState";

export const mapJobDetailsToVariableVM = (
  dto: AICodingJobDetailsDto,
  respondentsCount?: number,
  cachedCodedCount?: number,
): VariableItemVM | undefined => {
  if (!dto?.variables?.length) return undefined;

  const variableNames = dto.variables.map((v) => v.variableName ?? "");
  const variableReportingNames = dto.variables.map((v) => v.variableReportingName ?? "");
  const numberOfVariables = variableReportingNames.length;
  const hasRespondentsCount = respondentsCount !== undefined;
  const totalResponses = hasRespondentsCount ? (respondentsCount ?? 0) * numberOfVariables : undefined;
  const codedResponses = cachedCodedCount;
  const notCodedResponses = totalResponses !== undefined && codedResponses !== undefined
    ? Math.max(totalResponses - codedResponses, 0)
    : totalResponses;
  
  return {
    variableNames: variableReportingNames,
    batteryName: dto.variables[0].battery ?? "",
    question: dto.variables[0].questionLabel ?? "",
    stats: {
      total: totalResponses,
      coded: codedResponses,
      notCoded: notCodedResponses,
    },

    jobInfo: {
      variables: variableNames,
      codingType: dto.variables[0].params?.codingType ?? "",
      answerType: dto.variables[0].params?.isMultiCode ? "Multiple" : "Single",
      translation: dto.variables[0].params?.isTranslate ? (dto.variables[0].params?.translationEngine ?? "") : "",
      filter: dto.variables[0].params?.filters,
    },

    isExpanded: false,
  };
};
